<template>
<div id="common-footer" :class="{top: isTop}">
  <ul class="footer-list" :class="{top: isTop}">
    <li class="footer-item"><router-link :to="{name: 'Index'}">Topページ</router-link></li>
    <li class="footer-item"><router-link :to="{name: 'Lp'}">平成年表とは？</router-link></li>
    <li class="footer-item"><router-link :to="{name: 'Kiyaku'}">利用規約</router-link></li>
    <li class="footer-item"><router-link :to="{ name: 'Edit', params:{obj: {mode: 'new'}}}">投稿</router-link></li>
    <li class="footer-item"><a href="https://twitter.com/UMhGE4p2PDNsx0s" target="_blank">運営</a></li>
    <li class="footer-item"><a href="https://docs.google.com/forms/d/e/1FAIpQLSdYvwyS9RtSybs57SdJLEkZ-9selzeISazH3ATalnZhfYm01Q/viewform" target="_blank">運営へのお問い合わせ</a></li>
    <li class="footer-item"><a href="https://docs.google.com/forms/d/e/1FAIpQLSeF4VKKoa3hjbfja_1r1BAvurCPhCRMu_n6Rkh3wVyoFmghyg/viewform" target="_blank">要望・不具合のご連絡</a></li>
  </ul>
  <p class="copyright" :class="{top: isTop}">Copyright © 2019 平成年表 All Rights Reserved.</p>
</div>
</template>

<script>
export default {
  name: 'CommonFooter',
  props: {
    sheen: String
  },
  data () {
    return {
    }
  },
  computed: {
    isTop () {
      if (this.sheen === undefined) {
        return false
      } else if (this.sheen === '') {
        return false
      } else if (this.sheen === 'top') {
        return true
      }
      return false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
@import url("../../assets/css/common.css");
#common-footer{
  padding-top:100px;
  padding-bottom: 40px;
}
.footer-list {
  margin: 0 auto;
  text-align: center;
  font-size: 0;
}
.footer-list .footer-item {
  display: inline-block;
  padding: 0 15px;
  font-size: 0.8rem;
}
.footer-list .footer-item + .footer-item {
  border-left: 1px solid #ddd;
}
.copyright {
  margin-top: 30px;
  text-align: center;
  letter-spacing: 1px;
  font-size: 0.8rem;
}
.top {
  color: #fff !important;
  background-color: #D51522 !important;
}
.top a{
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommomFooter.vue